import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=09ea3ab4&scoped=true&lang=less"

import exportComponent from "C:\\Users\\liuqi\\Desktop\\R\\hkyl-fintech-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ea3ab4"]])

export default __exports__